<template>
	<div class="agree-page">
        <div class="agree-title">用户协议</div>
        <div class="tips">本协议是由您与翌飞锐特电子商务（北京）有限公司（以下简称“翌飞锐特”）共同签署。指尖货运小程序（以下简称“小程序”）为我司开发，指尖小店为指尖货运小程序中一个功能版块，便于您在手机浏览器或微信中直接使用指尖货运服务的便捷程序。</div>
        <div class="agree-content">
            <strong>一、特别提醒</strong>
            <div class="agree-detail">
                <p>在使用小程序之前，您需要仔细阅读本协议。</p>
                <p>小程序需要手机号授权方可使用，指尖小店为指尖货运小程序中为用户提供的特别功能，如您通过指尖货运小程序授权登录成为实际用户后，您可以直接使用您的注册信息登录指尖小店。</p>
                <p>您同意并确认，在您授权认证为小程序会员前，您已充分阅读、理解并接受本协议的全部内容，每当您使用小程序，都表示您已同意接受本协议的约束。</p>
                <p>您同意并确认，翌飞锐特有权根据需要不时地修改、制定本协议，并以公告的方式在小程序上予以公示；</p>
                <p>若您在本协议内容公告变更后继续使用小程序，表示您已充分阅读、理解修改后的协议内容，并视为您已接受新的服务协议；若您不同意修改后的协议内容，您应当立即停止使用小程序。</p>
            </div>
            <strong>二、注册条款</strong>
            <div class="agree-detail">
                <p>您理解并同意，小程序仅限个人用户注册。</p>
                <p>在您通过小程序注册个人用户时，您应当是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人。若您不具备前述主体资格，您应当立即停止注册或停止使用翌飞锐特的服务，由此导致的一切后果由您及您的监护人承担。</p>
                <p>当您通过小程序申请注册成为指尖货运的会员时，您需要提供您的手机号。</p>
                <p>若您注册成为指尖货运的会员或使用、接受指尖货运的服务，您同意：</p>
                <p>在注册时，向指尖货运提供真实、准确、即时、完整的注册信息及相应的证件资料并及时更新上述信息及资料以保持其真实、准确、即时、完整。</p>
                <p>在确知或者有合理理由怀疑您提供的信息不真实、不准确、不即时、不完整时，指尖货运有权暂停或终止对您的服务。</p>
                <p>因通过您提供的电子邮件地址、手机或座机号码等联系方式无法及时与您取得联系，导致您在使用小程序服务过程中产生任何损失或增加费用的，由您自行承担。</p>
                <p>您在使用小程序时,授权翌飞锐特有权以各种方式（包括但不限于电子邮件、手机短信）发送与翌飞锐特所提供服务相关的各类商业信息，如您拒绝继续接收上述商业信息，您可以选择退订方式通知翌飞锐特。</p>
            </div>
            <strong>三、账号管理</strong>
            <div class="agree-detail">
                <p>会员账号管理</p>
                <p>在您完成翌飞锐特指尖货运会员注册程序或以翌飞锐特允许的其他方式实际使用程序的服务时，翌飞锐特会向您提供唯一ID号的指尖货运账号（以下亦称“账号”）。您可以对账号设置用户名、密码，通过该用户名、密码或经翌飞锐特授权的其他关联或合作网站的用户名密码登录小程序。您设置的用户名不得违反法律规定、不得侵犯他人合法权益。</p>
                <p>您应当妥善保管您的用户名和密码，对于因密码泄露所致的损失，由您自行承担。您保证不向其他任何人泄露用户名及密码，如您发现任何人冒用或盗用您的用户名及密码或有任何其他可能危及您的账号安全的情形时，您应当立即以有效方式通知翌飞锐特，要求翌飞锐特暂停相关服务。您理解翌飞锐特对您的请求采取行动需要合理时间，翌飞锐特对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</p>
                <p>除非有法律依据且征得翌飞锐特的同意，否则，您的用户名和密码不得以任何方式转让、赠与或继承（与账号相关的财产权益除外）。</p>
    
            </div>
            <strong>四、使用条款</strong>
            <div class="agree-detail">
                <p>用户在使用小程序服务时，应遵守国家《计算机信息系统国际联网保密管理规定》、《中华人民共和国计算机信息系统安全保护条例》、《计算机信息网络国际联网安全保护管理办法》等相关法律法规以及本协议规定、翌飞锐特保险网的相关协议及规则，禁止任何违法违规行为，如：</p>
                <p>任何干扰或破坏小程序或与之相连的服务器和网络及从事其他干扰或破坏翌飞锐特服务的活动，将小程序作任何非法用途；</p>
                <p>通过小程序发布、传播含有以下内容的信息:</p>
                <p>
                    <span>(1) 有关宗教、种族或性别等的贬损言辞；</span>
                    <span>(2) 侵犯党和国家利益的言论；骚扰、滥用或威胁其他用户的信息、广告信息；</span>
                    <span>(3) 侵犯任何第三方著作权、专利、商标、商业秘密或其他专有权利或名誉权的信息；</span>
                    <span>(4) 其他任何违反国家相关法律法规的信息。</span>
                </p>
            </div>
            <strong>五、费用</strong>
            <div class="agree-detail">
                <p> 注册翌飞锐特指尖货运的会员及使用相应服务是免费的。翌飞锐特不负责对您因使用翌飞锐特指尖货运小程序服务而需支付的软硬件、税收及其他费用。</p>
            </div>
            <strong>六、责任声明</strong>
            <div class="agree-detail">
                <p>对使用小程序而产生的风险由用户自己承担，翌飞锐特明确不提供任何明示或者默示的担保。</p>
                <p>翌飞锐特对下列事项不作任何陈述与保证：</p>
                <p>您使用翌飞锐特的服务后所产生的任何行为，如购买或获得的任何产品、服务、信息或其他事物等，将符合您的要求或经验；</p>
                <p>翌飞锐特是不受干扰的、没有故障的，也不对使用效果做任何保证。您同意独立承担因网站意外中断、操作或传输的迟延、电脑病毒、网络连接故障、未经授权的进入等引起的损失。</p>
                <p>您因违反翌飞锐特的用户协议或其他有关的法律、法规，而导致有第三方对翌飞锐特提起诉讼或索赔要求时，您同意赔偿翌飞锐特因此遭受的所有损失，包括但不限于合理的律师费。</p>
                <p>用户对通过翌飞锐特获取的任何信息，用户需自己甄别，自负风险；对因下载或引用翌飞锐特的数据、信息而造成的用户计算机系统损坏或数据丢失，翌飞锐特不负责任。</p>
                <p>翌飞锐特对用户使用指尖货运上公布的或其服务中的建议和资讯而造成的损失或伤害以及用户相信指尖货运上的公布的或其服务中的建议和资讯而做出的决定或采取的行动不负责任。若您对翌飞锐特提供的部分或所有服务不满，您唯一的补救措施是停止使用这些服务。</p>
                <p>鉴于互联网的特殊性，因黑客攻击、互联网连通中断或者系统故障等情形给用户造成的损失，翌飞锐特不承担责任。</p>
            </div>
            <strong>七、知识产权声明</strong>
            <div class="agree-detail">
                <p>小程序上所有可阅读的资料等都受到《中华人民共和国著作权法》等的法律保护。</p>
                <p>小程序上所有内容的选材、整理、编排、排版，以及由翌飞锐特创作的文字、图片等作品的著作权，无论是否明示，均属翌飞锐特所有。任何组织或个人未经翌飞锐特书面许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的小程序上的内容。</p>
                <p>翌飞锐特对其开发或者合作开发的系统等享有知识产权。翌飞锐特的所有权利受法律保护。</p>
                <p>指尖货运，是翌飞锐特电子商务（北京）有限公司所有、使用的商标。</p>
                <p>所有其他在小程序上出现的商标为它们各自的权利人所有。</p>
                <p>翌飞锐特尊重和保护他人的知识产权。不允许在没有著作权、商标权或其他专有权权利人明确许可的情况下，发布或者传播任何可能侵犯他人权利的信息、图片。行为人承担由此产生的全部责任。</p>
            </div>
            <strong>八、协议终止</strong>
            <div class="agree-detail">
                <p>您同意：出现以下情形，翌飞锐特有权在告知或未经告知的情况下中止或终止向您提供部分或全部服务，暂时冻结或永久冻结（注销）您的账号，且无须因此向您或任何第三方承担任何责任，且保留追究您法律责任的权利：</p>
                <p>您向翌飞锐特提供的信息或资料不真实、不准确、不即时、不完整；</p>
                <p>实施或计划实施破坏、攻击翌飞锐特的电脑、移动端系统、网络的完整性，或者试图擅自进入翌飞锐特的电脑、移动端系统、网络；</p>
                <p>使用或提供含有毁坏、干扰、截取或侵占任何系统、数据或个人资料的任何电脑、移动端病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他破坏性程序；</p>
                <p>盗用他人在小程序上的用户名或密码；</p>
                <p>未经翌飞锐特书面同意，擅自允许他人使用翌飞锐特的服务（包括但不限于擅自允许他人使用其用户名或密码，或者擅自将其用户名或密码转让给他人的），或者通过触屏端或小程序获得相关信息。</p>
                <p>出现其他任何违法、违纪或违约的情形。</p>
                <p>对您在会员资格或服务中止或终止前的行为，翌飞锐特保留追究您法律责任的权利。</p>
            </div>
            <strong>九、法律适用及管辖</strong>
            <div class="agree-detail">
                <p>本协议条款的解释及适用，以及与本协议条款有关的争议，均应依照中华人民共和国法律予以处理。</p>
            </div>
        </div>
		
	</div>
</template>
<script babel>
	export default {
	}
</script>
<style scoped>
.agree-page {
    padding: 0.3rem;
    font-size: 0.26rem;
    background-color: #fff;
    color: #333;
}
.agree-page .agree-title {
    text-align: center;
    font-size: 0.3rem;
    color: #FF5226;
    font-weight: 600;
}
.agree-page .tips {
    border-radius: 0.08rem;
    padding: 0.1rem;
    margin: 0.3rem 0;
    line-height: 0.4rem;
}
.agree-page p {
    color: #333;
    line-height: 0.4rem;
    margin-bottom: 0.24rem;
}
.agree-page .agree-detail {
    margin: 0.2rem 0 0.15rem;
}
.agree-page .agree-content {
    border-radius: 0.08rem;
    padding: 0.1rem;
}
</style>